"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQueryFinishedWithData = exports.isQueryFinished = void 0;
/**
 * Is this query done giving me data?
 * @param query - Apollo Query response
 */
var isQueryFinished = function (query) {
    return (query.called && !query.loading);
};
exports.isQueryFinished = isQueryFinished;
var isQueryFinishedWithData = function (query) {
    return !!(exports.isQueryFinished(query) && query.data);
};
exports.isQueryFinishedWithData = isQueryFinishedWithData;
//# sourceMappingURL=apollo-helpers.js.map